function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterR({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M29,4L3,4L3,6.725L12.031,14.753L14.066,29L17.934,29L19.969,14.753L29,6.725L29,4ZM28,5L28,6L4,6L4,5L28,5ZM27.185,7L19.31,14L12.69,14L4.815,7L27.185,7ZM17.066,28L14.934,28L13.076,15L18.924,15L17.066,28Z",
    style: {
      fill: "rgb(108,108,108)",
      fillRule: "nonzero",
      stroke: "rgb(108,108,108)",
      strokeOpacity: 0,
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 32,
    height: 32,
    style: {
      fill: "none",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,16.1745,-0.167276)"
  }, /*#__PURE__*/React.createElement("text", {
    x: "2.987px",
    y: "29.168px",
    style: {
      fontFamily: "'AvenirNextLTPro-Regular', 'Avenir Next LT Pro', sans-serif",
      fontSize: "19.341px",
      fill: "rgb(108,108,108)"
    }
  }, "R")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterR);
export default __webpack_public_path__ + "static/media/filter_r.4afec6da71bdeb7b2c3436fb0ee9a04f.svg";
export { ForwardRef as ReactComponent };